import { forwardRef, SyntheticEvent, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Input } from '@app/form';
import { Button } from './Button';
import { Trans } from 'react-i18next';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    gap: theme.marginBase * 2,
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  icon: {
    fontSize: theme.iconSize.large,
    fontWeight: 400,
  },
  input: {
    flex: 1,
    minWidth: 120,
  },
  button: {
    flex: 1,
    gap: theme.marginBase,
  },
}));

interface Props {
  text: string;
  copyText: string;
}

export const CopyTextButton = forwardRef(
  ({ text, copyText }: Props, ref: any) => {
    const classes = useStyles();
    const newRef = useRef<HTMLInputElement | null>(null);

    const inputRef = ref || newRef;

    const onFocus = (e: SyntheticEvent<HTMLInputElement, FocusEvent>) => {
      e.currentTarget.select();
      document.execCommand('copy');
    };

    const onClick = () => inputRef.current && inputRef.current.focus();

    return (
      <div className={classes.container}>
        <div className={classes.input}>
          <Input
            noMargin
            value={text}
            readonly
            onFocus={onFocus}
            ref={inputRef}
          />
        </div>
        <Button
          onClick={onClick}
          contentClassName={classes.button}
          variant="muted"
        >
          <i className={classnames('ri-file-copy-line', classes.icon)} />
          {copyText}
        </Button>
      </div>
    );
  },
);
